/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Cost_Of_AnswerInputs */



/**
* | output |
* | --- |
* | "Cost of this answer" |
*
* @param {Chat_Cost_Of_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_cost_of_answer = /** @type {((inputs?: Chat_Cost_Of_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Cost_Of_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kosten dieser Antwort")
	return /** @type {LocalizedString} */ ("Cost of this answer")
});